export function formatPhoneNumber(phone: string) {
  return "+234" + phone.replace(/^(\+?234?)?0?/, "");
}
